import { useTranslation } from "react-i18next";
import { SettingField } from "@/components/settings/setting-field";
import { InfinityToggleInput } from "./infinity-toggle-input";

interface DailyLimitFieldProps {
  saving?: boolean;
}

/** Daily booking limit (`daily_max`). It applies in both capacity modes. */
export function DailyLimitField({ saving = false }: DailyLimitFieldProps) {
  const { t } = useTranslation("settings");

  return (
    <div id="field-limits-daily-max" className="flex items-center justify-between">
      <SettingField
        label={t("capacity.maxDailyAppointments")}
        helpText={t("capacity.dailyAppointmentsDescription")}
        className="text-base font-normal"
      />

      <InfinityToggleInput
        valueFieldName="dailyMax"
        placeholder="50"
        min={1}
        max={1000}
        saving={saving}
      />
    </div>
  );
}
